export default __webpack_public_path__ + "static/media/Tailwind.ea8ab441.PNG";